module.exports = __webpack_public_path__ + "img/typing2.fe6329af.png";